$bog_blitz_lobby_join $mol_page
	Head null
	is_synced false
	profile_avatar_uri \
	profile_name \
	syncing_title @ \Syncing...
	join_title @ \Syncing...
	enter_title @ \Enter
	Avatar_icon $mol_avatar
		id <= player_id \
	Avatar_image $mol_image
		uri <= avatar_uri \
	body /
		<= Avatar_circle $mol_view
			sub /
				<= avatar_preview null
		<= Avatar $mol_button_open
			sub /
				<= Avatar_label $mol_paragraph
					title @ \Change photo
				<= Avatar_native $mol_button_open_native
					files? <=> avatar_files? /File
					accept \image/*
					multiple false
		<= Player_name_input $mol_string_button
			hint @ \Touch to change your name
			value? <=> player_name? \
		<= Join $mol_button_major
			title <= join_title
			click? <=> join? null
